import { useState } from 'react';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-dark-bg flex">
      {/* Sidebar - desktop only */}
      <div className="hidden md:block">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />
      </div>

      {/* Main content - margem fixa baseada no estado */}
      <main className={`flex-1 transition-all duration-300 pb-16 md:pb-0 ${collapsed ? 'md:ml-16' : 'md:ml-56'}`}>
        {children}
      </main>

      {/* Bottom nav - mobile only */}
      <BottomNav />
    </div>
  );
}
